/**
 * Strecke — the waypoint list, the search over it and the airspace check, as the
 * inspector's first tab.
 *
 * The contents are the map's own panel (`map/RoutePanel`), which is where the
 * route editing has always lived; what changed is where it sits. The four things
 * it needs from the canvas come through the map bridge, so this pane renders
 * (and edits the route) even on a screen where no map is mounted.
 */
import { useRoute } from '../../planContext';
import { useT } from '../../i18n';
import { RoutePanel } from '../../map/RoutePanel';
import { useMapApi, useRouteTotalNm } from '../../map/mapBridge';

export function RoutePane({ readOnly = false }: { readOnly?: boolean }) {
  const t = useT();
  const map = useMapApi();
  const totalNm = useRouteTotalNm();
  const route = useRoute();
  const n = route?.waypoints.length ?? 0;

  return (
    <div className="ae-pane-inner">
      <div className="ae-pane-head">
        <h2 className="ae-eyebrow">{t('map.wp.title')}</h2>
        <span className="ae-chip ae-num">{n}</span>
        <button type="button" className="ae-btn ae-btn-quiet" onClick={map.fit} disabled={n === 0}>
          {t('map.fit')}
        </button>
      </div>
      <RoutePanel
        readOnly={readOnly}
        sheet={false}
        embedded
        totalNm={totalNm}
        onFit={map.fit}
        onFlyTo={map.flyTo}
        mapCentre={map.centre}
        onHighlight={map.setHighlight}
      />
    </div>
  );
}

export default RoutePane;
